module.exports = __webpack_public_path__ + "img/icon_1_42.85af230a.png";